(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusAssessControllers')
        .controller('RecomUpdateStatusAssessByActionPlanCriteriasController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', '$timeout', 'topBarService', 'govNotificationDelay', 'bUnit', 'govProcess', 'assessmentsByActionPlan', 'fiscalYearQuarterKeys'];

    function Controller($scope, $state, $stateParams, $timeout, topBarService, govNotificationDelay, bUnit, govProcess, assessmentsByActionPlan, fiscalYearQuarterKeys) {

        if ($state.is('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanCriterias')) {

            if (fiscalYearQuarterKeys.length === 0) {
                $state.go('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanNoCriterias',
                    {
                        ActionPlanID: $stateParams.ActionPlanID,
                    },
                    { location: 'replace' }
                );

                return;
            }

            if (assessmentsByActionPlan.ActionPlanAssessmentSummary.UseByQuarterPaging) {
                $state.go('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanCriteriasByQuarter',
                   {
                       ActionPlanID: $stateParams.ActionPlanID,
                       FiscalYearQuarterKey: fiscalYearQuarterKeys[0],
                   },
                   { location: 'replace' }
                );

                return;
            }
        }

        var title = bUnit.TitleEN + ' Action Plans | ' + govProcess.ShortName + ' Progress Tracking';
        topBarService.setTitleAndIcon(title, 'fa fa-road');

        $scope.ctrlCtxt = {};

        $scope.bUnit = bUnit;
        $scope.actionPlan = assessmentsByActionPlan.ActionPlan;
        $scope.actionPlanStatusList = assessmentsByActionPlan.ActionPlanStatusList;
        $scope.assessmentsByActionPlan = _.omit(assessmentsByActionPlan, 'ActionPlanCriteriaAssessments');
        $scope.critAssByQuarter = _.chain(assessmentsByActionPlan.ActionPlanCriteriaAssessments)
                                   .groupBy('ActionPlanCriteria.TargetFiscalYearAndQuarter')
                                   .map(function (critAssByQuarter) {
                                       var mapped = {
                                           TargetDateQuarterShortTitleEN: critAssByQuarter[0].ActionPlanCriteria.TargetDateQuarterShortTitleEN,
                                           TargetFiscalYear: critAssByQuarter[0].ActionPlanCriteria.TargetFiscalYear,
                                           TargetFiscalYearAndQuarter: critAssByQuarter[0].ActionPlanCriteria.TargetFiscalYearAndQuarter,
                                           ActionPlanCriteriaAssessments: critAssByQuarter
                                       };

                                       return mapped;
                                   })

                                   .value();



        // Go To Action Plan
        $scope.goToActionPlan = function () {
            if ($scope.assessmentsByActionPlan.ActionPlanAssessment.AreAllCriteriasAssessed) {
                $state.go('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanAssessment', {
                    ActionPlanID: $scope.actionPlan.ActionPlanID
                });

                return;
            }

            if (!$scope.isMissingAssessmentsShow) {
                $scope.isMissingAssessmentsShow = true;
                $timeout(function () {
                    $scope.isMissingAssessmentsShow = false;
                }, govNotificationDelay);
            }
        };
     
    }
})();